import React from "react";

import type { CustomCellRendererProps } from "ag-grid-react";
import { IWeightPullWeighIn } from "@eagerdog/interfaces";

import styles from "./WeighInsModal.module.scss";

// Renders the "Weight" column of the Weigh Ins grid: the recorded weight (+
// auto-computed weight class) or "Not Entered" when the dog hasn't been
// weighed in yet.
export const WeightCellRenderer = (props: CustomCellRendererProps<IWeightPullWeighIn>) => {
  const dogWeight = props.data?.dog_weight;
  const weightClass = props.data?.weight_class;

  if (!dogWeight || dogWeight <= 0) {
    return <span className={styles.notEntered}>Not Entered</span>;
  }

  return (
    <span className={styles.weightValue}>
      <strong>{dogWeight} lbs</strong>
      {weightClass ? <span className={styles.weightClassTag}> — {weightClass}</span> : null}
    </span>
  );
};
